import { sendTrackingEvent } from "@/requests/api/app";
import getEventProperties from "@/utils/eventManager";
import { useMutation } from "@tanstack/react-query";

const useTracking = () =>
  useMutation({
    mutationFn: async (event: IGetEventProperties | string) => {
      const eventToSend =
        typeof event === "string" ? { eventName: event } : event;
      const formattedEvent = getEventProperties({ ...eventToSend });

      if (!formattedEvent) return await Promise.resolve();

      return sendTrackingEvent(formattedEvent);
    },
  });

export { useTracking };
